import {default as map} from "./map.js";

export default {
    map
};
